module.exports = __webpack_public_path__ + "img/bg_s-100.70631aac.jpg";